module.exports = __webpack_public_path__ + "img/kw.c2b83a89.svg";